'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _reactAddonsPureRenderMixin = require('react-addons-pure-render-mixin');

var _reactAddonsPureRenderMixin2 = _interopRequireDefault(_reactAddonsPureRenderMixin);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classNames = require('react-utils/classNames');

var _classNames2 = _interopRequireDefault(_classNames);

var _UIIconHolder = require('./UIIconHolder');

var _UIIconHolder2 = _interopRequireDefault(_UIIconHolder);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

exports.default = _react2.default.createClass({
  displayName: 'UIIconCircle',

  mixins: [_reactAddonsPureRenderMixin2.default],

  propTypes: {
    backgroundColor: _UIIconHolder2.default.propTypes.backgroundColor,
    borderColor: _UIIconHolder2.default.propTypes.borderColor,
    borderStyle: _UIIconHolder2.default.propTypes.borderStyle,
    borderWidth: _UIIconHolder2.default.propTypes.borderWidth,
    verticalAlign: _UIIconHolder2.default.propTypes.verticalAlign,
    innerStyles: _react.PropTypes.object,
    iconClassName: _react.PropTypes.string,
    name: _UIIconHolder2.default.propTypes.name,
    color: _react.PropTypes.string,
    size: _react.PropTypes.number,
    padding: _react.PropTypes.number,
    legacy: _react.PropTypes.bool
  },

  getDefaultProps: function getDefaultProps() {
    return {
      borderWidth: 1,
      borderStyle: 'solid',
      padding: 0.75
    };
  },
  getBorderColor: function getBorderColor(borderColor, color) {
    if (borderColor) {
      return borderColor;
    }
    return color;
  },
  getPadding: function getPadding(padding, legacy) {
    return legacy ? 0 : padding;
  },
  render: function render() {
    var _props = this.props,
        backgroundColor = _props.backgroundColor,
        borderColor = _props.borderColor,
        borderStyle = _props.borderStyle,
        borderWidth = _props.borderWidth,
        className = _props.className,
        color = _props.color,
        iconClassName = _props.iconClassName,
        innerStyles = _props.innerStyles,
        legacy = _props.legacy,
        name = _props.name,
        padding = _props.padding,
        size = _props.size,
        style = _props.style,
        rest = _objectWithoutProperties(_props, ['backgroundColor', 'borderColor', 'borderStyle', 'borderWidth', 'className', 'color', 'iconClassName', 'innerStyles', 'legacy', 'name', 'padding', 'size', 'style']);

    var outerCircleClassNames = (0, _classNames2.default)('private-icon-circle__outer', { 'private-icon-circle--legacy': legacy }, className);
    var innerCircleClassNames = (0, _classNames2.default)('private-icon-circle__inner', iconClassName);
    return _react2.default.createElement(_UIIconHolder2.default, _extends({}, rest, {
      backgroundColor: backgroundColor,
      borderColor: this.getBorderColor(borderColor, color),
      borderRadius: '50%',
      borderStyle: borderStyle,
      borderWidth: borderWidth,
      className: outerCircleClassNames,
      innerClassName: innerCircleClassNames,
      size: size,
      padding: this.getPadding(padding, legacy),
      name: name,
      color: color,
      style: style,
      innerStyles: innerStyles,
      _fromUIIconCircle: true
    }));
  }
});
module.exports = exports['default'];